import React from 'react'
import { ButtonGroup, DialogWrapper } from '@reapitform/common-ui'
import { Button } from '@reapit/elements/core/button'

interface ConfirmDeleteDialogProps {
  isOpen: boolean
  title: string
  message: string
  busy?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/**
 * A small confirm-before-delete modal used throughout the admin app. The confirm button is destructive
 * (matches the agent app's DialogConfirmation intent="danger" convention for delete confirmations); the
 * caller performs the delete and surfaces any error (e.g. a 409 when a card/section still has children).
 */
export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  isOpen,
  title,
  message,
  busy,
  onConfirm,
  onCancel,
}) => {
  const footer = (
    <ButtonGroup alignment="right">
      <Button size="medium" variant="secondary" disabled={busy} onClick={onCancel} type="button">
        Cancel
      </Button>
      <Button
        size="medium"
        variant="primary"
        isDestructive
        isBusy={busy}
        disabled={busy}
        onClick={onConfirm}
        type="button"
      >
        Delete
      </Button>
    </ButtonGroup>
  )

  return (
    <DialogWrapper isModalOpen={isOpen} handlerModalClose={onCancel} hasCloseButton title={title} footer={footer}>
      {message}
    </DialogWrapper>
  )
}
